import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../app/store";
import Position from "../../../../api/models/portfolioPosition";
import { plainToInstance } from "class-transformer";

interface CollapsiblePositionState {
  positionSelected: object | undefined
}

const initialState: CollapsiblePositionState = {
  positionSelected: undefined
};

const collapsiblePositionSlice = createSlice({
  name: 'positionCollapsed',
  initialState,
  reducers: {
    setSelectedPosition(state, action: PayloadAction<object | undefined>) {
      state.positionSelected = action.payload;
    }
  }
});

// Export the auto-generated action creator with the same name
export const { setSelectedPosition } = collapsiblePositionSlice.actions;

// Export selectors
export const selectPositionSelected = createSelector([(state: RootState) => state.positionCollapsed.positionSelected], (positionSelected) => {
  if (positionSelected) {
    return plainToInstance(Position, positionSelected);
  } else {
    return undefined;
  }
})

// Export the generated reducer function
export default collapsiblePositionSlice.reducer;